
import React from 'react';
import Landing from '@/components/Landing';
import OGMetaTags from '@/components/common/OGMetaTags';

const LandingPage: React.FC = () => {
  return (
    <>
      <OGMetaTags 
        title="VirtuStaff.ai - AI-Powered Virtual Staff"
        description="Hire AI staff to automate your business functions and supercharge your productivity"
        path="/"
      />
      <Landing />
    </>
  );
};

export default LandingPage;
